import { supportsLocalStorage } from '@js/common/utils'

import { SalesAgentData } from '@f-fertighaus/applications/SalesAgentDashboard/interfaces/SalesAgentData'

export const SADB = (() => {
  const isLoggedIn: () => boolean = function () {
    const SADBToken = localStorage.getItem('SADBToken')
    const SADBTokenExpires = localStorage.getItem('SADBTokenExpires')

    if (SADBToken === null) {
      return false
    }

    if (new Date(Number(SADBTokenExpires)) > new Date()) {
      return true
    }

    doLogOut()
    return false
  }

  const doLogIn: ({
    token,
    expires
  }: {
    token: string
    expires: number
  }) => void = function ({ token, expires }) {
    localStorage.setItem('SADBToken', token)
    localStorage.setItem('SADBTokenExpires', expires.toString())
  }

  const doLogOut: () => void = function () {
    localStorage.removeItem('SADBToken')
    localStorage.removeItem('SADBTokenExpires')
    localStorage.removeItem('SADB')
  }

  const getToken: () => string = function () {
    return localStorage.getItem('SADBToken') || ''
  }

  const setLS: (userData: SalesAgentData) => void = function (
    saData: Partial<SalesAgentData> = {}
  ) {
    localStorage.setItem('SADB', JSON.stringify(saData))
  }

  const getLS: () => SalesAgentData = function () {
    const LS = localStorage.getItem('SADB') || '{}'
    let parsedLS = {}

    try {
      parsedLS = JSON.parse(LS)
    } catch (e) {}

    return parsedLS as SalesAgentData
  }

  return {
    isLoggedIn: supportsLocalStorage() ? isLoggedIn : () => false,
    doLogIn: supportsLocalStorage() ? doLogIn : () => {},
    doLogOut: supportsLocalStorage() ? doLogOut : () => {},
    getToken: supportsLocalStorage() ? getToken : () => '',
    setLS: supportsLocalStorage() ? setLS : () => {},
    getLS: supportsLocalStorage() ? getLS : () => ({})
  }
})()
